import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'SiteNavigation' })((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 40,
        width: '100%',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            flexDirection: 'column'
        }
    }
}));
